import each from 'lodash/each';
import merge from 'lodash/merge';

import masks from '@constants/masks';

import { unflatten, findObjectValuesByType } from '@utils/object';
import { uuid } from '@utils/string';

/**
 * Returns true if the given value is an object and has at least one File
 * @param {Object} value
 */
export const toMultipartFormData = data => {
    try {
        let form = new FormData();

        const files = findObjectValuesByType(data, File);

        each(files, (file, path) => {
            const key = uuid(8);

            form.append(key, file, file.name);
            data = merge(data, unflatten({ [path]: key }));
        });

        const json = JSON.stringify(data);

        const blob = new Blob([json], {
            type: 'application/json'
        });

        form.append('document', blob);

        return form;
    } catch (error) {
        console.error(error);
    }
};

/**
 * Get predefined mask options for Cleave.js
 * @param {String} key
 * @returns {Object}
 */
export const getMask = (key, options = null) => {
    const mask = masks[`${key}`];

    if (mask && typeof mask === 'function') {
        return mask(options);
    }

    return { ...mask, ...options };
};

export const getInput = $el => {
    if ($el && $el.tagName === 'INPUT') {
        return $el;
    }

    return $el.querySelector('input');
};
